import React, { useState } from 'react'
import cn from 'classnames'
import { connect } from 'react-redux'

import { cartProductsSelector } from 'store/selectors/cart'

import Edit from 'assets/svg/edit.svg'

import ProductForm from './ProductForm'
import ProductFormLayoutMobile from './ProductFormLayoutMobile'

import {
    Container,
    Content,
    Card,
    DivImage,
    Info,
    Desc,
    Title,
    Subtitle,
    Front,
    Back,
    Text,
    Link,
    Button,
    Actions
} from './ProductContainerMobile.style'

const ProductContainerMobile = ({ product, cartProducts }) => {
    const [flipped, setFlipped] = useState(false)

    const cartProductInfo = cartProducts.find((cartProduct) => {
        return +product.code === +cartProduct.id
    })

    const className = product.type === 'TUDO' ? 'tudo' : 'pod'

    return (
        <Container>
            <Card className={cn(className, { flipped: flipped })}>
                <Front className={flipped ? 'flipped' : ''}>
                    <Content>
                        <Info>
                            <DivImage $gradientColor={product.bgMobile}>
                                <img
                                    id={product.id}
                                    src={product.image}
                                    alt={`Produto ${product.name}`}
                                />
                            </DivImage>
                            <Title>{product.title}</Title>
                            <Subtitle $color={product.color}>
                                Cartão com benefícios flexíveis
                            </Subtitle>
                            <Desc>{product.desc}</Desc>
                            <Text>{product.text}</Text>
                        </Info>
                        <Actions>
                            {!cartProductInfo ? (
                                <Button
                                    id={`btnAdd${product.name}`}
                                    type="button"
                                    className="width-90"
                                    onClick={() => setFlipped((flip) => !flip)}
                                >
                                    Eu quero!
                                </Button>
                            ) : (
                                <Button
                                    id={`btnEdit${product.name}`}
                                    type="button"
                                    kind="edit"
                                    onClick={() => setFlipped((flip) => !flip)}
                                >
                                    <img src={Edit} alt="Edit" />
                                    Editar cesta
                                </Button>
                            )}
                            <Link href={product.link}>Saiba mais</Link>
                        </Actions>
                    </Content>
                </Front>

                <Back className={flipped ? 'flipped' : ''}>
                    <ProductForm product={product}>
                        <ProductFormLayoutMobile setFlipped={setFlipped} />
                    </ProductForm>
                </Back>
            </Card>
        </Container>
    )
}

const mapStateToProps = (state) => ({
    cartProducts: cartProductsSelector(state)
})

export default connect(mapStateToProps)(ProductContainerMobile)
